import { render, staticRenderFns } from "./PFormCheckBox.vue?vue&type=template&id=09388847&scoped=true"
import script from "./PFormCheckBox.vue?vue&type=script&lang=ts"
export * from "./PFormCheckBox.vue?vue&type=script&lang=ts"
import style0 from "./PFormCheckBox.vue?vue&type=style&index=0&id=09388847&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09388847",
  null
  
)

export default component.exports